import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "./store";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import * as typeformEmbed from "@typeform/embed";
import axios from "axios";
import { storage } from "@/common/storage";
import AsyncComputed from 'vue-async-computed'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import moment from 'moment'
import * as user from '@/services/userService'
import { factoryModels } from '@/data/factoryModels'
import VueModelFactory from 'vue-model-factories'

const factory = new VueModelFactory().define(factoryModels).build()

if (process.env.VUE_APP_ENVIRONMENT === 'staging' || process.env.VUE_APP_ENVIRONMENT === 'production') {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    environment: process.env.VUE_APP_ENVIRONMENT,
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
  });
}


axios.setAuthHeaders = function () {
  this.defaults.headers.common = {'Authorization': `Bearer ${storage.getItem('access_token')}`}
}

if (storage.getItem('access_token')) {
  axios.defaults.headers.common = {'Authorization': `Bearer ${storage.getItem('access_token')}`}
}

Vue.prototype.$typeformEmbed = typeformEmbed;
Vue.prototype.$http = axios;
Vue.prototype.$moment = moment;
Vue.prototype.$user = user;
Vue.prototype.$factory = factory;


Object.defineProperty(Vue.prototype, '$storage', {
  value: storage
})

Vue.use(VueMaterial);
Vue.use(AsyncComputed);

Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
